/**
 * Frontend 使用的功能型接口路径。
 *
 * 路径不携带 /api、/frontend、/admin 等终端前缀。后端路由切换时只需调整本文件，
 * 页面和业务 API 不直接拼写接口地址。
 */
export const API_PATHS = {
  auth: {
    smsSend: '/auth/sms/send/',
    smsLogin: '/auth/sms/login/',
    passwordLogin: '/auth/password/login/',
    register: '/auth/register/',
    context: '/auth/context/',
    registrationConfig: '/auth/registration-config/',
    ssoCreate: '/auth/sso-tickets/',
    ssoRedeem: '/auth/sso-tickets/redeem/',
  },
  invitation: {
    preview: '/workspace/invitations/preview/',
    register: '/workspace/invitations/register/',
  },
  workspace: {
    registrationOptions: '/workspace/registration-options/',
    onboardingSelect: '/workspace/onboarding/select/',
    joinApplicationCancel: (applicationId: number) =>
      `/workspace/join-applications/${applicationId}/cancel/`,
    transferApplications: '/workspace/transfer-applications/',
    transferApplicationContext: '/workspace/transfer-applications/form-context/',
    transferApplicationCancel: (applicationId: number) =>
      `/workspace/transfer-applications/${applicationId}/cancel/`,
  },
  permissions: {
    catalog: '/permissions/',
  },
} as const
